// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  expansionPanelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    margin: 0,
  },
  expansionPanelHeaders: {
    display: 'none',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    margin: 0,
    backgroundColor: 'rgba(248, 248, 248, 1)',
  },
  select: {
    display: 'flex',
    fontSize: '0.875rem',
    fontWeight: 400,
    marginLeft: '20px',
    marginBottom: '5px',
    width: '75%',
  },
  processingText: {
    padding: '2px 10px',
    color: '#ffffff',
    lineHeight: '8px',
    background: 'linear-gradient(90deg, #9038F5 0%, #3C34B7 33.29%, #2075FE 74.06%, #01A1DD 100%)',
  },
  expressIconImg: {
    width: '20px',
  },
  fileName: {
    display: 'flex',
    fontSize: '13px',
    fontWeight: 400,
    marginLeft: theme.spacing(3),
    marginBottom: theme.spacing(1),
    color: '#788898',
    maxWidth: '80%',
    wordBreak: 'break-all',
  },
  dot: {
    fontSize: '30px',
    lineHeight: 0.75,
    marginRight: theme.spacing(1),
  },
  toolTipFiles: {
    backgroundColor: 'rgba(64, 64, 64, 0.8)',
    color: '#FFFFFF',
    boxShadow: theme.shadows[1],
    fontSize: '11px',
    flex: 1,
  },
  wrapper: {
    paddingBottom: theme.spacing(1),
    backgroundColor: 'rgba(248, 248, 248, 1)',
  },
  layerSection: {
    marginBottom: theme.spacing(1),
  },
  layerName: {
    marginLeft: theme.spacing(1),
    color: '#021E40',
  },
  sliderbtn: {
    marginLeft: 'auto',
    marginRight: '8px',
    padding: '4px',
  },
  adjustpannelicon: {
    width: '20px',
    height: '20px',
  },
  fileItalic: {
    marginTop: '5px',
    width: '100%',
    height: '40px',
    fontFamily: 'Work Sans',
    fontWeight: 400,
    fontStyle: 'italic',
    fontSize: '14px',
    lineHeight: '100%',
    letterSpacing: '0.6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'rgba(28, 54, 75, 0.6)',
    backgroundColor: 'rgba(248, 248, 248, 1)',
  },
  ongroundfilechange: {
    fontSize: '0.875rem',
    ml: 2,
    mb: 1,
    maxWidth: 'calc(100% - 100px)',
    '& .MuiSelect-select': {
      paddingLeft: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  onaerialfilechange: {
    fontSize: '0.875rem',
    ml: 2,
    mb: 1,
    maxWidth: 'calc(100% - 100px)',
    '& .MuiSelect-select': {
      paddingLeft: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
});

export default styles;
